
import { Component, Prop, Vue } from 'vue-property-decorator';
import { WPXFormValue } from '@/components/templates/WPXForm';
import {
  ProfileInterface,
  ProfileRepositoryInterface,
} from '@/services/Users-profile/interfaces';
import { EditUserProfileForm } from '@/services/Users-profile/forms/EditUserProfileForm';

@Component({
  inject: [
    'profileRepository',
  ],
})
export default class EditUserProfile extends Vue {
  @Prop() private readonly userId: string;
  private readonly profileRepository!: ProfileRepositoryInterface;
  private birthDateMenu: string = '';
  private firstDayMenu: string = '';
  private lastDayMenu: string = '';

  private loading: boolean = true;
  private profile!: ProfileInterface;
  private image: File = {} as File;
  private form: WPXFormValue<EditUserProfileForm> = new WPXFormValue(EditUserProfileForm);

  private async created(): Promise<void> {
    if (!this.userId) {
      await this.$router.push({ name: 'users_index' });
      this.$notifications.error('UserId not provided');

      return;
    }
    this.profile = await this.profileRepository.getOneByUserId(this.userId);
    this.assignFormData();
    this.loading = false;
  }

  private async editProfile(): Promise<void> {
    const profileData = this.fetchFormData();

    try {
      await this.profileRepository.updateProfile(this.userId, profileData, this.image);
      this.$successDialog.show('Profile Updated Successfully');
    } catch (e) {
      this.$errorDialog.show(JSON.stringify(e));
    }
  }

  private fetchFormData(): Partial<ProfileInterface> {
    return {
      userId: this.userId,
      personalDetails: {
        birthDate: new Date(this.form.data.personalDetails.birthDate),
        firstName: this.form.data.personalDetails.firstName,
        lastName: this.form.data.personalDetails.lastName,
        fullName: this.form.data.personalDetails.fullName,
      },
      companyDetails: {
        department: this.form.data.companyDetails.department,
        position: this.form.data.companyDetails.position,
        firstDay: new Date(this.form.data.companyDetails.firstDay),
        lastDay: this.form.data.companyDetails.lastDay ? new Date(this.form.data.companyDetails.lastDay) : undefined,
      },
      contacts: {
        phoneNumber: this.form.data.contacts.phoneNumber,
        discordUsername: this.form.data.contacts.discordUsername,
      },
    };
  }

  private assignFormData(): void {
    if (!this.profile) {
      return;
    }

    Object.keys(this.form.data).forEach((formDataKey: string) => {
      if (!this.profile[formDataKey]) {
        return;
      }

      Object.assign(this.form.data[formDataKey], this.profile[formDataKey]);
    });
  }
}
